import React, { useState, useEffect } from "react";
import "../../style/sample.css";
import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    IconButton,
    Collapse,
} from "@mui/material";
import {
    ExpandLess as ExpandLessIcon,
    ExpandMore as ExpandMoreIcon,
} from "@mui/icons-material";
import ReceiptLongSharpIcon from '@mui/icons-material/ReceiptLongSharp';
import PaymentsSharpIcon from '@mui/icons-material/PaymentsSharp';
import AccountBalanceSharpIcon from '@mui/icons-material/AccountBalanceSharp';
import InsightsSharpIcon from '@mui/icons-material/InsightsSharp';
import ReceiptSharpIcon from '@mui/icons-material/ReceiptSharp';
import AssessmentSharpIcon from '@mui/icons-material/AssessmentSharp';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import BusinessSharpIcon from '@mui/icons-material/BusinessSharp';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { styled } from '@mui/material/styles';
import { Routes, Route, Link, Navigate, useLocation } from "react-router-dom";
import LogoArpariWhite from "../../style/frontpage/img/arpari-logos/Logo-Arpari-navy.png";
import logoArpariWhiteCollapsed from "../../style/frontpage/img/arpari-logos/favicon/android-chrome-512x512.png";
import Payments from "./payments/sendFundsUnit/index";
import Analytics from "./analytics/index";
import BankAccountHierarchy from "./bankAccountsHierarchy/index.js";
import PlacementSettings from "./bankAccountPlacementSettings/index.js";
import Logout from "../authenticate/logout";
import HoldingEntities from "./entity/holdingEntities";
import TeamPermissions from "./team/TeamPermissions";
import userSessionCheck from "../../helpers/userSessionCheck";
import HoldingEntity from "./entity/holdingEntityDetails";
import MyAccountsIndex from "./bankAccountsAll/index";
import ReconnectBankAccounts from "./reconnectAccounts/index";
import Transactions from "./transactions/index";
import PendingTransactions from "./transactions/pendingTransactions";
import { cancelPreviousPageRequests } from "../../helpers/callBackend";
import { PortfolioProvider } from "../../helpers/contexts/PortfolioContext";
import { PortfolioDetailsProvider } from "../../helpers/contexts/PortfolioDetailsContext";
import { PaymentsProvider } from "../../helpers/contexts/PaymentsContext";
import { TeamProvider } from "../../helpers/contexts/TeamContext";
import { PayablesProvider } from "../../helpers/contexts/PayablesContext";
import Reports from "./reports";
import ReportDetails from "./reports/reportDetails";
import RuleDetails from "./transactions/ruleDetails";
import AccountView from "../../components/bankAccount/accountView";
import ManageConnectionsIndex from "./bankAccountsManageConnections/index";
import ManageConnectionsDetails from "./bankAccountsManageConnections/manageConnectionsDetails/index";
import GenericHeader from "../../components/generic/genericHeader";
import MenuFoldOutlined from '@ant-design/icons/MenuFoldOutlined';
import MenuUnfoldOutlined from '@ant-design/icons/MenuUnfoldOutlined';
// unused
import theme from "../../helpers/theme";
import { ThemeProvider } from '@mui/material/styles';
import GeneralLedger from "./transactions/generalLedger";
import CustomTags from "./transactions/customTags";
import { BreadCrumbProvider } from "../../helpers/contexts/BreadCrumbContext";

import AparDash from "./ap_ar/shared/AparDash";
import InvoiceDetailsSession from "./ap_ar/shared/InvoiceDetailsSession";

import PersonalInformation from "./userAccount/PersonalInformation.jsx";
import Approvals from "./payments/approvals/Approvals.jsx";
import PendingRequests from "./payments/pendingRequests/PendingRequests.jsx"
import checkFlag from "../../helpers/featureFlags.js";
import SendFundsPage from "./payments/sendFundsDwolla/SendFundsPage.jsx";
import ManageRecipients from "./payments/recipients/ManageRecipients.jsx";
import { UserCompanySettingsContext } from "../../helpers/contexts/UserCompanySettingsContext.jsx";
import FrequentlyAskedQuestions from "../../components/specific/faq/faq.js";
import InactivityTracker from "../../helpers/security/InactivityTracker.jsx";
import TransactionsCounterparties from './transactions/counterparties/TransactionsCounterparties.jsx';
import TransactionCounterpartyDetails from "./transactions/counterparties/counterpartiesDetails/TransactionCounterpartyDetails.jsx";
import ReportsCustomPage from "./reports/reports-custom/ReportsCustomPage.jsx";
import AddOrEditReportPage from "./reports/reports-custom/AddOrEditReportPage.jsx";
import ReportsCustomDetailsPage from "./reports/reports-custom/ReportsCustomDetailsPage.jsx";

const currentCompanyName = JSON.parse(localStorage.getItem("arpariAffiliatedCompany"))?.company_name || "";
const storedCompanyData = JSON.parse(localStorage.getItem("arpariCompanyListData")) || [];
const drawerWidth = 220;
const drawerWidthCollapsed = 0;

const LogoImage = styled('img')(({ theme, collapsed }) => ({
    height: collapsed ? '40px' : '70px',
    margin: '0px 30px',
    marginBottom: '0px',
}));


const listStyles = {
    '& .MuiListItem-button': {
        '&:hover': {
            backgroundColor: theme.palette.primary.lighter,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.primary.lighter,
            borderRight: `2px solid ${theme.palette.primary.main}`,
            '& .MuiListItemText-root, & .MuiListItemIcon-root': {
                color: theme.palette.primary.main,
            },
        },
    },
    '& a': {
        color: 'inherit',
        textDecoration: 'none',
        '&:hover': {
            color: 'inherit',
        },
    },
};

const openedMixin = (theme) => ({
    width: drawerWidth,
    borderRight: '1px solid',
    borderRightColor: theme.palette.divider,

    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),

    overflowX: 'hidden',
    boxShadow: 'none'
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),

    overflowX: 'hidden',
    width: 0,
    borderRight: 'none',
    boxShadow: theme.customShadows.z1
});

const Dashboard = () => {
    const [collapsed, setCollapsed] = useState(false);
    const [bankAccountsCollapsed, setBankAccountsCollapsed] = useState(false);
    const [aparCollapsed, setAparCollapsed] = useState(true);
    const [transactionsCollapsed, setTransactionsCollapsed] = useState(true);
    const [reportsCollapsed, setReportsCollapsed] = useState(false);
    const [companiesData, setCompaniesData] = useState(storedCompanyData);
    const [hasMounted, setHasMounted] = useState(false);
    const location = useLocation();
    const [paymentsCollapsed, setPaymentsCollapsed] = useState(true)

    const isSoftwareCustomer = JSON.parse(localStorage.getItem("isSoftwareCustomer"))
    const isBankingCustomer = JSON.parse(localStorage.getItem("isBankingCustomer"))

    useEffect(() => {
        setHasMounted(true);
        document.title = "Arpari | Dashboard";
        userSessionCheck();
        sortCompaniesData(companiesData);
    }, []);

    const sortCompaniesData = (companies) => {
        if (companies.length === 0) {
            return;
        }

        companies.sort((a, b) => {
            const nameA = a.company_name.toUpperCase();
            const nameB = b.company_name.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
        setCompaniesData(companies);
    };

    const isActivePath = (path) => {
        return location.pathname === path;
    };

    const menuContent = (
        <Box sx={{ display: "flex", overflowX: "hidden", overflowY: "hidden" }}>
            <Drawer
                variant="permanent"
                anchor="left"
                sx={{
                    width: collapsed ? drawerWidthCollapsed : drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: {
                        width: collapsed ? drawerWidthCollapsed : drawerWidth,
                        boxSizing: "border-box",
                        overflow: 'hidden',
                        backgroundColor: 'white',
                    },
                    [`& .MuiListItem-root`]: {
                        py: collapsed ? 1 : 0.5,
                    },
                    width: drawerWidth,
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    boxSizing: 'border-box',
                    ...(!collapsed && {
                        ...openedMixin(theme),
                        '& .MuiDrawer-paper': openedMixin(theme)
                    }),
                    ...(collapsed && {
                        ...closedMixin(theme),
                        '& .MuiDrawer-paper': closedMixin(theme)
                    })
                }}
                open={!collapsed}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Link to="/home">
                        <LogoImage
                            src={collapsed ? logoArpariWhiteCollapsed : LogoArpariWhite}
                            alt="Arpari Logo"
                            collapsed={collapsed}
                        />
                    </Link>
                </Box>
                <Box style={{ height: '100vh' }}>
                    <List sx={listStyles}>
                        <>
                            {!currentCompanyName.startsWith("[Demo]") && (
                                <ListItem button component={Link} to="/analytics" selected={isActivePath('/analytics')}>
                                    <ListItemIcon sx={{ minWidth: 20 }}>
                                        <InsightsSharpIcon sx={{ fontSize: 16 }} />
                                    </ListItemIcon>
                                    {!collapsed && <ListItemText primary="Analytics" sx={{ ml: 1 }} />}
                                </ListItem>
                            )}
                            <ListItem button onClick={() => setBankAccountsCollapsed(prevState => !prevState)}>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <AccountBalanceSharpIcon sx={{ fontSize: 16 }} />
                                </ListItemIcon>
                                {!collapsed && <ListItemText primary="Bank Accounts" sx={{ ml: 1 }} />}
                                <IconButton
                                    sx={{
                                        color: '#152e4d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    {!collapsed && (bankAccountsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />)}
                                </IconButton>
                            </ListItem>
                            <Collapse in={!bankAccountsCollapsed} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button component={Link} to="/accounts" selected={isActivePath('/accounts')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="View By Hierarchy"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    <ListItem button component={Link} to="/all-accounts" selected={isActivePath('/all-accounts')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="View All"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    <ListItem button component={Link} to="/manage-connections" selected={isActivePath('/manage-connections')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Manage Connections"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    <ListItem button component={Link} to="/placement-settings" selected={isActivePath('/placement-settings')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Placement Settings"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                </List>
                            </Collapse>
                            <ListItem button onClick={() => setPaymentsCollapsed((prevState) => !prevState)}>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <PaymentsSharpIcon sx={{ fontSize: 16 }} />
                                </ListItemIcon>
                                {!collapsed && <ListItemText primary='Payments' sx={{ ml: 1 }} />}
                                <IconButton
                                    sx={{
                                        color: '#152e4d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    {!collapsed && (paymentsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />)}
                                </IconButton>
                            </ListItem>
                            <Collapse in={!paymentsCollapsed} timeout='auto' unmountOnExit>
                                <List component='div' disablePadding>
                                    {isBankingCustomer && (
                                        <ListItem button component={Link} to='/payments' selected={isActivePath('/payments')}>
                                            {!collapsed && (
                                                <ListItemText
                                                    inset
                                                    primary={isSoftwareCustomer ? 'Arpari Payments' : 'Send Funds'}
                                                    primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                                />
                                            )}
                                        </ListItem>
                                    )}
                                    {isSoftwareCustomer && (
                                        <>
                                            <ListItem button component={Link} to='/send-funds' selected={isActivePath('/send-funds')}>
                                                {!collapsed && (
                                                    <ListItemText
                                                        inset
                                                        primary={isBankingCustomer ? 'Third Party Payments' : 'Send Funds'}
                                                        primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                                    />
                                                )}
                                            </ListItem>
                                            <ListItem
                                                button
                                                component={Link}
                                                to='/payment-requests'
                                                selected={isActivePath('/payment-requests')}
                                            >
                                                {!collapsed && (
                                                    <ListItemText
                                                        inset
                                                        primary='Pending Requests'
                                                        primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                                    />
                                                )}
                                            </ListItem>
                                            <ListItem
                                                button
                                                component={Link}
                                                to='/payment-approvals'
                                                selected={isActivePath('/payment-approvals')}
                                            >
                                                {!collapsed && (
                                                    <ListItemText
                                                        inset
                                                        primary='Approvals'
                                                        primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                                    />
                                                )}
                                            </ListItem>
                                        </>
                                    )}
                                    <ListItem
                                        button
                                        component={Link}
                                        to='/manage-recipients'
                                        selected={isActivePath('/manage-recipients')}
                                    >
                                        {!collapsed && (
                                            <ListItemText
                                                inset
                                                primary='Recipients'
                                                primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                            />
                                        )}
                                    </ListItem>
                                </List>
                            </Collapse>
                            <ListItem button onClick={() => setAparCollapsed(prevState => !prevState)}>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <ReceiptLongSharpIcon sx={{ fontSize: 16 }} />
                                </ListItemIcon>
                                {!collapsed && <ListItemText primary="AP/AR" sx={{ ml: 1 }} />}
                                <IconButton
                                    sx={{
                                        color: '#152e4d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    {!collapsed && (aparCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />)}
                                </IconButton>
                            </ListItem>
                            <Collapse in={!aparCollapsed} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button component={Link} to="/payables" selected={isActivePath("/payables")} >
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Accounts Payable"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    <ListItem button component={Link} to="/receivables" selected={isActivePath("/receivables")}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Accounts Receivable"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                </List>
                            </Collapse>
                            {/* TRANSACTIONS */}
                            <ListItem button onClick={() => setTransactionsCollapsed(prevState => !prevState)}>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <ReceiptSharpIcon sx={{ fontSize: 16 }} />
                                </ListItemIcon>
                                {!collapsed && <ListItemText primary="Transactions" sx={{ ml: 1 }} />}
                                <IconButton
                                    sx={{
                                        color: '#152e4d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    {!collapsed && (transactionsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />)}
                                </IconButton>
                            </ListItem>
                            <Collapse in={!transactionsCollapsed} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button component={Link} to="/transactions" selected={isActivePath('/transactions')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="View All"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    {false &&
                                        <ListItem button component={Link} to="/pending-transactions" selected={isActivePath('/pending-transactions')}>
                                            {!collapsed && <ListItemText
                                                inset
                                                primary="Pending"
                                                primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                            />}
                                        </ListItem>}
                                    <ListItem button component={Link} to="/general-ledger" selected={isActivePath('/general-ledger')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="General Ledger"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    <ListItem button component={Link} to="/custom-tag" selected={isActivePath('/custom-tag')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Custom Tag"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    {checkFlag('transactionsCounterparties') && (
                                        <ListItem button component={Link} to="/transaction-counterparties" selected={isActivePath('/transaction-counterparties')}>
                                            {!collapsed && <ListItemText
                                                inset
                                                primary="Counterparties"
                                                primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                            />}
                                        </ListItem>
                                    )}
                                </List>
                            </Collapse>

                            {/* REPORTS */}

                            <ListItem button onClick={() => setReportsCollapsed(prevState => !prevState)}>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <AssessmentSharpIcon sx={{ fontSize: 16 }} />
                                </ListItemIcon>
                                {!collapsed && <ListItemText primary="Reports" sx={{ ml: 1 }} />}
                                <IconButton
                                    sx={{
                                        color: '#152e4d',
                                        backgroundColor: 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'transparent',
                                        },
                                    }}
                                >
                                    {!collapsed && (reportsCollapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />)}
                                </IconButton>
                            </ListItem>
                            <Collapse in={!reportsCollapsed} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <ListItem button component={Link} to="/reports" selected={isActivePath('/reports')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Templates"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                    <ListItem button component={Link} to="/reports-custom" selected={isActivePath('/reports-custom')}>
                                        {!collapsed && <ListItemText
                                            inset
                                            primary="Custom"
                                            primaryTypographyProps={{ sx: { fontSize: '12px', ml: -2 } }}
                                        />}
                                    </ListItem>
                                </List>
                            </Collapse>

                        </>
                        <ListItem button component={Link} to="/holding-entities" selected={isActivePath('/holding-entities')}>
                            <ListItemIcon sx={{ minWidth: 20 }}>
                                <BusinessSharpIcon sx={{ fontSize: 16 }} />
                            </ListItemIcon>
                            {!collapsed && <ListItemText primary="Holding Entities" sx={{ ml: 1 }} />}
                        </ListItem>

                    </List>
                </Box>
                <List sx={listStyles}>
                    {false &&
                        <ListItem button component={Link} to="/faq" selected={isActivePath('/faq')}>
                            <ListItemIcon sx={{ minWidth: 20 }}>
                                <LiveHelpIcon sx={{ fontSize: 16 }} />
                            </ListItemIcon>
                            {!collapsed && <ListItemText primary="FAQ" sx={{ ml: 1 }} />}
                        </ListItem>}
                    <ListItem button component={Link} to="/logout" selected={isActivePath('/logout')}>
                        <ListItemIcon sx={{ minWidth: 20 }}>
                            <LogoutOutlined sx={{ fontSize: 16 }} />
                        </ListItemIcon>
                        {!collapsed && <ListItemText primary="Logout" sx={{ ml: 1 }} />}
                    </ListItem>
                </List>
            </Drawer>
            <Box
                component="main"
                sx={{
                    flex: 1,
                    bgcolor: "background.default",
                    width: collapsed ? '100vw' : 'calc(100vw - 220px)',
                    transition: 'none',
                }}
            >
                <IconButton
                    onClick={() => setCollapsed(prevState => !prevState)}
                    size="large"
                    sx={{
                        position: 'absolute',
                        top: '8px',
                        left: collapsed ? drawerWidthCollapsed : drawerWidth,
                        color: '#152e4d',
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        zIndex: 1000,
                    }}
                >
                    {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </IconButton>
                <Box sx={{ transition: 'none', flex: 1, backgroundColor: 'white', maxWidth: '100%', position: 'relative' }}>
                    <GenericHeader style={{ position: 'absolute', top: 0, left: 0, right: 0, zIndex: 10 }} />
                    <Box sx={{
                        backgroundColor: 'secondary.lighter',
                        overflowY: 'hidden',
                        height: 'calc(100vh - 60px)',
                        overflowX: 'hidden',
                        transition: 'none',
                    }}>
                        <Routes>
                            <Route exact path="/accounts" element={<BankAccountHierarchy />} />
                            <Route exact path="/placement-settings" element={<PlacementSettings />} />
                            <Route exact path="/transactions" element={<Transactions />} />
                            <Route exact path="/pending-transactions" element={<PendingTransactions />} />
                            <Route exact path="/general-ledger" element={<GeneralLedger />} />
                            <Route exact path="/general-ledger/rule/details/:id" element={<RuleDetails label="General Ledger" url="general-ledger" />} />
                            <Route exact path="/custom-tag/rule/details/:id" element={<RuleDetails label="Custom Tag" url="generic-tag" />} />
                            <Route exact path="/custom-tag" element={<CustomTags />} />
                            <Route exact path='/transaction-counterparties' element={<TransactionsCounterparties />} />
                            <Route exact path='/transaction-counterparties/details/:id' element={<TransactionCounterpartyDetails />} />
                            <Route exact path="/payments" element={<Payments />} />
                            <Route exact path="/send-funds" element={<SendFundsPage />} />
                            <Route exact path="/payment-requests" element={<PendingRequests />} />
                            <Route exact path="/payment-approvals" element={<Approvals />} />
                            <Route exact path="/manage-recipients" element={<ManageRecipients />} />
                            <Route exact path="/payables" element={<AparDash title="Payable" />} />
                            <Route exact path="payables/payableinvoice/:entityId/:invoiceId" element={<InvoiceDetailsSession invoiceType="payable" />} />
                            <Route exact path="/receivables" element={<AparDash title="Receivable" />} />
                            <Route exact path="receivables/receivableinvoice/:entityId/:invoiceId" element={<InvoiceDetailsSession invoiceType="receivable" />} />
                            <Route exact path="/analytics" element={<Analytics />} />
                            {/* <Route exact path="/account" element={<Account />} /> */}
                            <Route exact path="/account" element={<PersonalInformation />} />
                            <Route exact path="/team" element={<TeamPermissions />} />
                            <Route path="/home" element={<Navigate to={"/accounts"} />} />
                            <Route path="/manage-connections" element={<ManageConnectionsIndex />} />
                            <Route path="/manage-connections/details/:id" element={<ManageConnectionsDetails />} />
                            <Route exact path="/all-accounts" element={<MyAccountsIndex />} />
                            <Route exact path="/all-accounts/reconnect/" element={<ReconnectBankAccounts />} />
                            <Route exact path="/holding-entities" element={<HoldingEntities />} />
                            <Route exact path="/holding-entities/details/:id" element={<HoldingEntity />} />
                            <Route exact path="/bank-accounts/details/:id" element={<AccountView />} />
                            <Route exact path="/reports" element={<Reports />} />
                            <Route exact path="/reports/details/:id" element={<ReportDetails />} />
                            <Route exact path="/faq" element={<FrequentlyAskedQuestions />} />
                            <Route exact path="/logout" element={<Logout />} />
                            <Route exact path="/reports-custom" element={<ReportsCustomPage />} />
                            <Route path="/reports-custom/editing/details/:id" element={<AddOrEditReportPage />} />
                            <Route path="/reports-custom/details/:id" element={<ReportsCustomDetailsPage />} />
                        </Routes>
                    </Box>
                </Box>
            </Box>
        </Box>
    );

    return (
        <>
            {menuContent}
        </>
    );
};

let previousPath = "";
let currentPath = "";

const DashboardWrapper = (props) => {
    const location = useLocation();

    useEffect(() => {
        if (!previousPath && !currentPath) {
            previousPath = location.pathname;
            currentPath = location.pathname;
        } else {
            previousPath = currentPath;
            currentPath = location.pathname;
        }
        if (previousPath !== currentPath) {
            cancelPreviousPageRequests(previousPath);
        }
    }, [location.pathname]);

    return (
        <ThemeProvider theme={theme}>
            <InactivityTracker>
                <UserCompanySettingsContext>
                    <BreadCrumbProvider>
                        <PaymentsProvider>
                            <TeamProvider>
                                <PayablesProvider>
                                    <PortfolioProvider>
                                        <PortfolioDetailsProvider>
                                            <Dashboard {...props} />
                                        </PortfolioDetailsProvider>
                                    </PortfolioProvider>
                                </PayablesProvider>
                            </TeamProvider>
                        </PaymentsProvider>
                    </BreadCrumbProvider>
                </UserCompanySettingsContext>
            </InactivityTracker>
        </ThemeProvider>
    );
};

export default DashboardWrapper;
